import React, { useEffect } from 'react';


const Test = () => {

 const aud = {
  "Q": "../culture/chunchun.mp3",
  "W": "../culture/engrish.mp3",
  "E": "../culture/giorno.mp3",
  "A": "../culture/im-batman.mp3",
  "S": "../culture/kaizoku.mp3",
  "D": "../culture/konodio.mp3",
  "Z": "../culture/niconico.mp3",
  "X": "../culture/poi.mp3",
  "C": "../culture/yeah_boy.mp3"
 }

 const handleClick = (id, text) => {
  document.getElementById(id).play();
  document.getElementById("display").innerText = text;
 }

 const handleKeyUp = (e) => {
  var x = e.key;
  switch (true) {
   case x === 'a' || x === 'A': document.getElementById("A").play(); break;
   case x === 'q' || x === 'Q': document.getElementById("Q").play(); break;
   case x === 'w' || x === 'W': document.getElementById("W").play(); break;
   case x === 'e' || x === 'E': document.getElementById("E").play(); break;
   case x === 's' || x === 'S': document.getElementById("S").play(); break;
   case x === 'd' || x === 'D': document.getElementById("D").play(); break;
   case x === 'z' || x === 'Z': document.getElementById("Z").play(); break;
   case x === 'x' || x === 'X': document.getElementById("X").play(); break;
   case x === 'c' || x === 'C': document.getElementById("C").play(); break;
   default: ;
  }
 }

 useEffect(() => {

  document.addEventListener('keyup', (event) => handleKeyUp(event));
  return (e) => document.removeEventListener('keyup', handleKeyUp(e));
 }, []);

 return (
  <div id="drum-machine">
   <h2 id="display">asdf</h2>

   <div>
    <button className="drum-pad" id="chun" onClick={() => handleClick("Q", "qq")}>
     <audio className="clip" src={aud.Q} id="Q" />
      Q</button>
    <button className="drum-pad" id="engrish" onClick={() => handleClick("W", "ww")} >
     <audio className="clip" src={aud.W} id="W" />
    W</button>
    <button className="drum-pad" id="giorno" onClick={() => handleClick("E", "ee")} >
     <audio className="clip" src={aud.E} id="E" />
    E</button>
    <button className="drum-pad" id="batman" onClick={() => handleClick("A", "aa")} >
     <audio className="clip" src={aud.A} id="A" />
    A</button>
    <button className="drum-pad" id="kaizoku" onClick={() => handleClick("S", "ss")} >
     <audio className="clip" src={aud.S} id="S" />
    S</button>
    <button className="drum-pad" id="dio" onClick={() => handleClick("D", "dd")} >
     <audio className="clip" src={aud.D} id="D" />
    D</button>
    <button className="drum-pad" id="nico" onClick={() => handleClick("Z", "zz")} >
     <audio className="clip" src={aud.Z} id="Z" />
    Z</button>
    <button className="drum-pad" id="poi" onClick={() => handleClick("X", "xx")} >
     <audio className="clip" src={aud.X} id="X" />
    X</button>
    <button className="drum-pad" id="yeah_boy" onClick={() => handleClick("C", "cc")} >
     <audio className="clip" src={aud.C} id="C" />
    C</button>
   </div>
  </div>
 )
}

export default Test;